<template>
  <el-dialog
    :visible="loginForm"
    class="loginType"
    @close="closeLogin"
    :show-close="emailStemp == 0"
  >
    <i class="el-icon-arrow-left" v-if="emailStemp != 0" @click="goBack"></i>
    <p>
      <img class="logo" src="../assets/image/logo.png" alt="" />
    </p>
    <div class="btn" v-if="emailStemp == 0">
      <p>{{ $t("loginDig") }}</p>
      <p>
        <el-button class="email" @click="emailLogin"
          ><svg viewBox="0 -200 2000 1024" width="40" height="18">
            <path
              d="M149.6 171.8h691.9c47.2 0 85.9 37.7 86.5 83.9L495.7 493 63.5 256c0.4-46.4 38.8-84.2 86.1-84.2z m-86.1 175l-0.4 419.6c0 46.7 38.9 84.9 86.5 84.9h691.9c47.6 0 86.5-38.2 86.5-84.9V346.6L505.9 572.8c-6.5 3.5-14.3 3.5-20.7 0l-421.7-226z"
              p-id="2609"
              data-spm-anchor-id="a313x.7781069.0.i2"
              class="selected"
            ></path></svg
          ><span>Email</span></el-button
        >
      </p>
      <p>
        <el-button class="facebook" @click="loginIn(6)"
          ><svg
            viewBox="0 0 36 36"
            focusable="false"
            aria-hidden="true"
            role="img"
            class="SocialButton-Icon"
          >
            <path
              d="M2 3v30a1 1 0 0 0 1 1h16.092V21.607h-4.169v-4.828h4.17v-3.556c0-3.45 2.012-6.049 5.209-6.37a34.474 34.474 0 0 1 4.736.176v4.32h-2.565c-1.016 0-2.385.424-2.385 1.531 0 .888-.008 3.831-.008 3.9h4.782l-.622 4.83h-4.16V34H33a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z"
            ></path></svg
          ><span>Facebook</span></el-button
        >
      </p>
      <p>
        <el-button class="google" @click="loginIn(7)"
          ><svg
            viewBox="0 0 1152 1152"
            focusable="false"
            aria-hidden="true"
            role="img"
            class="spectrum-Icon spectrum-Icon--sizeS SocialButton-Icon"
          >
            <path
              d="M1055.994 594.42a559.973 559.973 0 0 0-8.86-99.684h-458.99V683.25h262.28c-11.298 60.918-45.633 112.532-97.248 147.089v122.279h157.501c92.152-84.842 145.317-209.78 145.317-358.198z"
              fill="#4285f4"
            ></path>
            <path
              d="M588.144 1070.688c131.583 0 241.9-43.64 322.533-118.07l-157.5-122.28c-43.64 29.241-99.463 46.52-165.033 46.52-126.931 0-234.368-85.728-272.691-200.919H152.636v126.267c80.19 159.273 245 268.482 435.508 268.482z"
              fill="#34a853"
            ></path>
            <path
              d="M315.453 675.94a288.113 288.113 0 0 1 0-185.191V364.482H152.636a487.96 487.96 0 0 0 0 437.724z"
              fill="#fbbc05"
            ></path>
            <path
              d="M588.144 289.83c71.551 0 135.792 24.589 186.298 72.88l139.78-139.779C829.821 144.291 719.504 96 588.143 96c-190.507 0-355.318 109.21-435.508 268.482L315.453 490.75c38.323-115.19 145.76-200.919 272.691-200.919z"
              fill="#ea4335"
            ></path>
          </svg>
          <span>Google</span></el-button
        >
      </p>
      <p>
        <el-button class="apple" @click="loginIn(5)"
          ><svg
            viewBox="0 0 36 36"
            focusable="false"
            aria-hidden="true"
            role="img"
            class="SocialButton-Icon"
          >
            <path
              d="M30.911 26.729a17.913 17.913 0 0 1-1.775 3.19 16.19 16.19 0 0 1-2.285 2.762 4.438 4.438 0 0 1-2.937 1.294 7.366 7.366 0 0 1-2.714-.648 7.779 7.779 0 0 0-2.921-.646 8.042 8.042 0 0 0-3 .646 8.07 8.07 0 0 1-2.6.682 4.174 4.174 0 0 1-3-1.328 17.008 17.008 0 0 1-2.39-2.86A19.763 19.763 0 0 1 4.758 24.8 18.381 18.381 0 0 1 3.7 18.816 10.932 10.932 0 0 1 5.132 13.1a8.429 8.429 0 0 1 3.005-3.04A8.089 8.089 0 0 1 12.2 8.912a9.555 9.555 0 0 1 3.142.731 10.073 10.073 0 0 0 2.493.733 14.892 14.892 0 0 0 2.765-.863 9.143 9.143 0 0 1 3.758-.667 7.976 7.976 0 0 1 6.249 3.29 6.953 6.953 0 0 0-3.687 6.315 6.965 6.965 0 0 0 2.288 5.249 7.5 7.5 0 0 0 2.285 1.5q-.274.8-.582 1.529zM24.543 1.672a7.038 7.038 0 0 1-1.8 4.618 6.151 6.151 0 0 1-5.107 2.521 5.2 5.2 0 0 1-.038-.626 7.232 7.232 0 0 1 1.915-4.666 7.355 7.355 0 0 1 2.327-1.751 6.957 6.957 0 0 1 2.668-.756 5.862 5.862 0 0 1 .035.66z"
            ></path></svg
          ><span>Apple</span></el-button
        >
      </p>
      <el-checkbox v-model="checked" class="checkBox">{{
        $t("expirationTime")
      }}</el-checkbox>
    </div>
    <div v-if="emailStemp == 1" class="emailLogin">
      <p>{{ $t("loginDig") }}</p>
      <div>
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item class="form-item" prop="email">
            <el-input
              clearable
              size="large"
              prefix-icon="el-icon-user"
              v-model="form.email"
              :placeholder="$t('emailHolder')"
            ></el-input>
          </el-form-item>
          <el-form-item class="form-item" prop="password">
            <el-input
              clearable
              prefix-icon="el-icon-lock"
              v-model="form.password"
              type="password"
              :placeholder="$t('passwordHolder')"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="forgetPas" @click="changePassword">
          {{ $t("forgetPas") }}
        </div>
        <el-button class="emailLoginBtn" type="primary" @click="doEmailLogin">{{
          $t("loginIn")
        }}</el-button>
      </div>
    </div>
    <div v-if="emailStemp == 2" class="changePas">
      <p>{{ $t("changePas") }}</p>
      <el-form ref="form2" :model="form2" :rules="rules2">
        <el-form-item class="form-item" prop="email">
          <el-input
            clearable
            size="large"
            prefix-icon="el-icon-user"
            v-model="form2.email"
            :placeholder="$t('emailHolder')"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item yanzhengma" prop="verificationCode">
          <el-input
            clearable
            size="large"
            prefix-icon="el-icon-message"
            v-model="form2.verificationCode"
            :placeholder="$t('codeHolder')"
          ></el-input>
          <el-button
            v-show="showCodeBtn"
            size="mini"
            type="primary"
            round
            style="float: right; margin-top: 6px"
            @click="sendEmail"
            >{{ $t("getCode") }}</el-button
          >
          <el-button
            v-show="!showCodeBtn"
            style="float: right; margin-top: 6px"
            size="mini"
            round
            >{{ downNum }}s</el-button
          >
        </el-form-item>
        <el-form-item class="form-item" prop="password">
          <el-input
            clearable
            prefix-icon="el-icon-lock"
            v-model="form2.password"
            :placeholder="$t('newPasswordHolder')"
            type="password"
          ></el-input>
        </el-form-item>
        <el-form-item class="form-item" prop="repassword">
          <el-input
            clearable
            prefix-icon="el-icon-lock"
            v-model="form2.repassword"
            :placeholder="$t('newPasswordHolder2')"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button class="emailChangeBtn" type="primary" @click="doChangePas">{{
        $t("submit")
      }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { emailLogin, emailSendCode, retrievePass } from "@/api/login";
import { mapGetters } from "vuex";
import { setToken } from "@/utils/auth"; // getToken from cookie
export default {
  data() {
    // var checkEmail = (rule, value, callback) => {
    //   const mailReg = /^*/;
    //   if (!value) {
    //     return callback(new Error(this.$i18n.t("emailNotEmpty")));
    //   }
    //   setTimeout(() => {
    //     if (mailReg.test(value)) {
    //       callback();
    //     } else {
    //       callback(new Error(this.$i18n.t("emailFormat")));
    //     }
    //   }, 100);
    // };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$i18n.t("newPasswordHolder2")));
      } else if (value !== this.form2.password) {
        callback(new Error(this.$i18n.t("newPasswordError")));
      } else {
        callback();
      }
    };
    return {
      downNum: 30,
      timer: null,
      showCodeBtn: true,
      checked: true,
      emailStemp: 0, //0登录类型1邮箱登录2邮箱重置密码
      form: {
        loginType: 8,
      },
      form2: {},
      rules: {
        email: [{required: true, trigger: "blur" }],
        password: [
          {
            required: true,
            message: this.$i18n.t("newPasswordHolder"),
            trigger: "blur",
          },
        ],
      },
      rules2: {
        email: [{ required: true, trigger: "blur" }],
        verificationCode: [
          {
            required: true,
            message: this.$i18n.t("codeHolder"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 6,
            message: this.$i18n.t("codeLimit"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$i18n.t("newPasswordHolder"),
            trigger: "blur",
          },
          {
            min: 4,
            max: 20,
            message: this.$i18n.t("passwordLimit"),
            trigger: "blur",
          },
        ],
        repassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["loginForm"]),
  },

  methods: {
    loginIn(type) {
      window.location.href =
        process.env.BASE_URL +
        "/webshop/api/oauth/login?loginType=" +
        type +
        "&keepLogin=" +
        this.checked +
        "&language=" +
        localStorage.getItem("locale");
    },
    // 邮箱登录
    emailLogin() {
      this.emailStemp = 1;
    },
    doEmailLogin() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          emailLogin(this.form).then((res) => {
            this.$message.success(this.$i18n.t("loginSuccess"));
            setToken(res.accessToken);
            window.location.reload();
          });
        }
      });
    },
    // 发送邮箱验证码
    sendEmail() {
      if (this.form2.email) {
        emailSendCode({ email: this.form2.email })
          .then((res) => {
            this.showCodeBtn = false;
            this.countDown();
            this.$message.success(this.$i18n.t("codeSend"));
          })
          .catch(() => {});
      } else {
        this.$message.error(this.$i18n.t("emailHolder"));
      }
    },
    countDown() {
      this.timer = setInterval(() => {
        this.downNum--;
        if (this.downNum == 0) {
          this.showCodeBtn = true;
          this.downNum = 30;
          window.clearInterval(this.timer);
        }
      }, 1000);
    },
    // 修改邮箱密码
    doChangePas() {
      this.$refs["form2"].validate((valid) => {
        if (valid) {
          retrievePass(this.form2).then((res) => {
            this.$message.success(this.$i18n.t("pasSendSuccess"));
            this.form.email = this.form2.email;
            this.emailStemp = 1;
          });
        }
      });
    },
    // 返回按钮
    goBack() {
      this.emailStemp--;
    },
    changePassword() {
      this.emailStemp = 2;
    },
    closeLogin() {
      this.$store.dispatch("clickLogin", false);
    },
  },
};
</script>
<style lang="scss">
.loginType {
  text-align: center;
  z-index: 9999;
  .el-icon-arrow-left {
    position: absolute;
    font-size: 26px;
    left: 40px;
  }
  .logo {
    width: 120px;
    height: auto;
  }
  .btn {
    // text-align: center;
    p {
      height: 76px;
      font: normal bold 16px/76px arial, sans-serif;
      .SocialButton-Icon {
        display: inline-block;
        vertical-align: top;
        height: 18px;
        width: 18px;
        margin-right: 16px;
        margin-top: -2px;
        fill: #fff;
      }
    }
    .el-button {
      width: 260px;
      border-radius: 40px;
      font-size: 15px;
    }
    .facebook {
      background-color: #3b5998;
      color: #ffffff;
    }
    .google {
      background-color: #ffffff;
      color: #000000;
    }
    .apple {
      background-color: #000000;
      color: #ffffff;
    }
    .email {
      background-color: #e3e3e3;
      color: #000000;
      padding-top: 8px;
    }
  }
  .emailLogin {
    .form-item {
      margin: 30px 0 0 40px;
      border-bottom: 1px solid #ffffff;
      width: 260px;
    }
    p {
      height: 76px;
      font: normal bold 16px/76px arial, sans-serif;
    }
    .el-input__inner {
      border: none;
      background: #d1d1d1;
      text-indent: 20px;
    }
    input::-webkit-input-placeholder {
      color: #666666;
    }
    input::-moz-input-placeholder {
      color: #666666;
    }
    input::-ms-input-placeholder {
      color: #666666;
    }
    .el-input__icon {
      color: #666666;
    }
    .forgetPas {
      text-align: right;
      margin: 20px 60px 0 0;
      color: #409eff;
      cursor: pointer;
    }
    .emailLoginBtn {
      margin-top: 40px;
    }
  }
  .changePas {
    .form-item {
      margin-left: 40px;
      border-bottom: 1px solid #ffffff;
      width: 264px;
    }
    .yanzhengma {
      .el-input {
        float: left;
        width: 160px;
      }
    }
    p {
      height: 76px;
      font: normal bold 16px/76px arial, sans-serif;
    }
    .el-input__inner {
      border: none;
      background: #d1d1d1;
      text-indent: 20px;
    }
    input::-webkit-input-placeholder {
      color: #666666;
    }
    input::-moz-input-placeholder {
      color: #666666;
    }
    input::-ms-input-placeholder {
      color: #666666;
    }
    .el-input__icon {
      color: #666666;
    }
    .emailChangeBtn {
      margin-top: 10px;
    }
  }
  .el-dialog {
    background: #d1d1d1;
    height: 560px;
    width: 400px;
    .el-dialog__body {
      padding-top: 0;
    }
  }
  .checkBox {
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loginType.vue